'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * @ngdoc service
 * @name $valeurFormat
 * @function
 *
 * @description
 * Number formatter based on numeraljs.
 *
 */
ngModule.factory("$valeurFormat", function (stringUtils) {
  var $valeurFormat = function $valeurFormat(value, fixedDecimals, signed) {
    if (value == null) {
      return "-";
    }
    var isSigned = !_.isUndefined(signed);
    var isFixedDecimals = !_.isUndefined(fixedDecimals);
    var format;
    if (isFixedDecimals) {
      var nbDecimals = parseInt(fixedDecimals);
      format = "0,0." + stringUtils.repeatSequence("0", nbDecimals);
    } else {
      format = "0,0.[00]";
    }
    var res = numeral(value.valeur).format(format);
    // todo - sans doute à intégrer dans la pattern de format
    if (isSigned) {
      if (numeral(value.valeur) > 0.0000001) {
        res = "+" + res;
      }
    }
    if (value.type === 'ESTIME') {
      res += "*";
    }
    return res;
  };
  return $valeurFormat;
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/types/valeurFormat.js
// module id = 2737
// module chunks = 13